import $ from "jquery";

export class GoogleAddressAutocomplete {

    constructor(inputSelector, ulSelector, parentSelector) {
    	const $parent = $(parentSelector);

        this.userCurrentPosition;

        this.$list = $(ulSelector, $parent);
        this.$input = $(inputSelector, $parent);
		this.selectedPlaceId = window.localStorage.getItem('user.lastPlaceIdOrderedFrom');
		this.currentAddressText = "";

        this.geocoder = new google.maps.Geocoder();
        this.autompleteService = new google.maps.places.AutocompleteService();

        this.$input.on("input", (evt) => this.onInput(evt));
        this.$input.on("focus", (evt) => this.onFocus(evt));
        this.$input.on("focusout", (evt) => this.onFocusOut(evt));
        this.$list.on("click", "li", (evt) => this.onResultClick(evt));

        this.$areaValid = $("#area-valid", $parent);
        this.$areaInvalid = $("#area-invalid", $parent);
        this.$kitchenBusy = $("#kitchen-busy", $parent);
        this.$findingKitchen = $("#finding-kitchen", $parent);
        this.$orderNowButton = $(".js-order-now");
        this.$myLocationButton = $(".my-location-icon, .my-location-button", $parent).hide();
        this.$submitSearchButton = $(".js-submit-search", $parent).attr('disabled', 'disabled');

		this.$orderNowButton.on("click", (evt) => this.onOrderNowClick(evt));
        this.$myLocationButton.on("click", (evt) => this.onMyLocationClick(evt));
        this.$myLocationButton.on("hover", (evt) => this.onMyLocationHover(evt));
		this.$submitSearchButton.on("click", (evt) => this.onSubmitSearchClick(evt))

		const lastAddressOrderedFrom = window.localStorage.getItem('user.lastAddressOrderedFrom');
		if(lastAddressOrderedFrom) {
			this.$input.val(lastAddressOrderedFrom);
			this.$submitSearchButton.removeAttr("disabled");
		}

        this.hideMessages();
    }

    hideMessages() {
        this.$areaValid.fadeOut();
        this.$areaInvalid.fadeOut();
        this.$kitchenBusy.fadeOut();
        this.$findingKitchen.fadeOut();
    }

    requestDeviceLocationAccess() {
    	return new Promise((resolve, reject) => {
			if(navigator.geolocation) {
				navigator.geolocation.getCurrentPosition((position) => {
					this.userCurrentPosition = {
						lat: position.coords.latitude,
						lng: position.coords.longitude
					};
					resolve();
				}, (err) => {
					reject(err);

					// Test location that is served
					// this.userCurrentPosition = {
					// 	lat: -33.931673,
					// 	lng: 18.409076
					// };

					// Test location that is not served
					// this.userCurrentPosition = {
					// 	lat: -33.791827,
					// 	lng: 18.459515
					// };

					// resolve();
				});
			}
		});
    }

    onOrderNowClick(evt) {
		evt.preventDefault();
    	let lastAreaOrderedFrom = window.localStorage.getItem('user.lastAreaOrderedFrom');
    	if(lastAreaOrderedFrom) {
			const $triggerElem = $("#" + lastAreaOrderedFrom.replace(/ /g, "_").toLowerCase() + " span");
			$triggerElem.trigger('click');
		} else {
			this.onMyLocationClick()
				.catch((error) => {
					window.location.href = "/#order-now";
				});
		}
	}

	onSubmitSearchClick(evt) {
		this.geocoder.geocode({ placeId: this.selectedPlaceId }, (results) => {
			let { lat, lng } = results[0].geometry.location.toJSON();

			this.getDeliveryAreas(lat, lng);
		});
	}

    onMyLocationClick(evt) {
		return this.requestDeviceLocationAccess()
			.then(() => {
				return new Promise((resolve, reject) => {
					this.geocoder.geocode({
						location: new google.maps.LatLng(this.userCurrentPosition.lat, this.userCurrentPosition.lng)
					}, (results) => {
						let { formatted_address, place_id } = results[0];

						this.selectedPlaceId = place_id;
						this.currentAddressText = formatted_address;
						resolve(formatted_address);
					});
				});
			})
			.then((formatted_address) => {
				this.$input.val(formatted_address);
				return this.getDeliveryAreas(this.userCurrentPosition.lat, this.userCurrentPosition.lng);
			});
    }

    onMyLocationHover(evt) {
		$('#plane').src= '/wp-content/themes/oishi/assets/img/test.svg';
	}

    onFocus(evt) {
		this.$myLocationButton.fadeIn().show();
	};

	onFocusOut(evt) {
		this.$myLocationButton.fadeOut();
	};

	onInput(evt) {
        this.hideMessages();

		this.$submitSearchButton.attr('disabled', 'disabled');

        $('#location_pin').hide();
        $('#google-address-autocomplete').css('padding-left', '20px');

		let { value } = evt.currentTarget;

        if(value && value !== "") {
            this.autompleteService.getPlacePredictions({
                input: value,
                types: [ 'address' ],
                componentRestrictions: { country: 'za' }
            }, (results) => this.renderResults(results));
        } else {
            this.renderResults([]);
			$('#location_pin').show();
			$('#google-address-autocomplete').css('padding-left', '52.25px');
        }
    }

    onResultClick(evt) {
        let index = this.$list.find("li").index(evt.currentTarget);
        const { place_id, description } = this.lastResultSet[index];

		this.selectedPlaceId = place_id;
        this.currentAddressText = description;

		this.$input.val(description);
		this.renderResults([]);
		this.$submitSearchButton.removeAttr('disabled');

    }

    getDeliveryAreas(lat, lng) {
        return new Promise((resolve, reject) => {
			$.post(
				window.ADMIN_AJAX_URL,
				{
					action: 'get_delivery_area',
					lat,
					lng
				},
				(response) => {
					let results = JSON.parse(response);

					if(results.length) {
						if(results[0].area_enabled) {
							this.$areaValid.fadeIn();
							this.$findingKitchen.fadeIn();

							window.localStorage.setItem('user.lastPlaceIdOrderedFrom', this.selectedPlaceId);
							window.localStorage.setItem('user.lastAddressOrderedFrom', this.currentAddressText);
							window.localStorage.setItem('user.lastAreaOrderedFrom', results[0].area_name);
							const $triggerElem = $("#" + results[0].area_name.replace(/ /g, "_").toLowerCase() + " span");
							$triggerElem.trigger('click');
							resolve();
						} else {
							this.$kitchenBusy.fadeIn();
							reject();
						}
					} else {
						// No results found
						reject();
						this.$areaInvalid.fadeIn();
					}
				}
			);
		});
    }

    renderResults(results) {
        this.lastResultSet = results;

        let listItemsHTML = '';
        results.forEach((result) => {
            let { main_text, main_text_matched_substrings, secondary_text } = result.structured_formatting;

            listItemsHTML += `
                <li>
                    <a>
                        <img src="/wp-content/themes/oishi/assets/img/Website_Location.svg">
                     
            `;

            let styled_text = main_text;
            main_text_matched_substrings.forEach((matched_substr) => {
                let matched_text = main_text.substr(matched_substr.offset, matched_substr.length);

                styled_text = styled_text.replace(matched_text, `<span class="text-dark-gray">${matched_text}</span>`);
            });

            listItemsHTML += `
                        <span class="text-oishi-dark-blue">${styled_text}</span>
                        <div>
                            <small class="text-dark-gray">${secondary_text}</small>
                        </div>
                    </a>
                </li>
            `;
        });

        this.$list.html(listItemsHTML);
    }

}
